import { Link } from 'react-router-dom';

export function EmailVerified() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="flex justify-center items-center space-x-2">
          <Link to="/" className="flex items-center space-x-2">
            <img src="/logo.png" alt="" className="h-8 w-8" />
            <img src="/logo-text.png" alt="Statsmatic" className="h-6" />
          </Link>
        </div>

        <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-sm">
          <div className="w-16 h-16 bg-green-50 border border-green-200 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="text-xl font-semibold text-gray-900 text-center mb-3">Email Verified</h1>
          <p className="text-gray-600 text-center mb-6">
            Your email has been verified successfully. You can now log in to your account.
          </p>
          <Link
            to="/login"
            className="block w-full py-3 px-4 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-lg transition-colors text-center"
          >
            Go to Login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default EmailVerified;
